import script from "./ComHuonekortit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekortit.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__